import { IDeleteItemProcessoFatorUseCase } from "../../../presentation/useCases/delete/delete_item_processos_fator_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// DeleteItemProcessoFatorUseCase

export class DeleteItemProcessoFatorUseCase implements IDeleteItemProcessoFatorUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async deleteItemProcessoFator( IdItemProcessoFator: number, IdItemProcesso: number): Promise<void> {
    await this.repository.deleteItemProcessoFator(IdItemProcessoFator, IdItemProcesso );
  }
}
